import socket from '../service/socketService';

/**
 * Utility to broadcast notification events via socket
 * This helps update the notification UI in real-time when notifications are sent
 */
export const broadcastNotificationUpdate = (toUserId?: string | string[]) => {
  try {
    socket.emit('notificationSent', {
      to: toUserId,
      timestamp: new Date().toISOString(),
    });

    // Also emit general notification event
    socket.emit('newNotification', {
      to: toUserId,
      timestamp: new Date().toISOString(),
    });
  } catch (error) {
    console.error('Error broadcasting notification update:', error);
  }
};

/**
 * Utility to determine notification category based on message content
 */
export const getNotificationCategory = (message: string): string => {
  if (message.toLowerCase().includes('rating')) {
    return 'Rating Request';
  }
  if (message.toLowerCase().includes('approval')) {
    return 'Approval Request';
  }
  if (message.toLowerCase().includes('review')) {
    return 'Review Request';
  }
  return 'General';
};

/**
 * Utility to get notification priority based on content
 */
export const getNotificationPriority = (title?: string, message?: string): 'high' | 'medium' | 'low' => {
  const content = `${title || ''} ${message || ''}`.toLowerCase();

  if (content.includes('urgent') || content.includes('immediate')) {
    return 'high';
  }
  if (content.includes('request') || content.includes('approval')) {
    return 'medium';
  }
  return 'low';
};
